import { render, staticRenderFns } from "./NomenclatureDropdownFooterTemplate.vue?vue&type=template&id=5bbc91a8&"
import script from "./NomenclatureDropdownFooterTemplate.vue?vue&type=script&lang=js&"
export * from "./NomenclatureDropdownFooterTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports